// extracted by mini-css-extract-plugin
module.exports = {"removeBtn":"style_removeBtn__1cbXC"};